// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.List-module__root--EvFgj {
  list-style: none;
  padding: 0;
  margin: 0;
}

.List-module__column-1--FBq86,
.List-module__column-2--INPn_,
.List-module__column-3--YBuOR,
.List-module__column-4--VjOIR,
.List-module__column-5--AyO38,
.List-module__column-6--TzCND {
  display: grid;
  column-gap: 28px;
}

.List-module__column-1--FBq86 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.List-module__column-2--INPn_ {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.List-module__column-3--YBuOR {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.List-module__column-4--VjOIR {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.List-module__column-5--AyO38 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.List-module__column-6--TzCND {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

.List-module__ui-List-Item--xAUcA {
  list-style: none;
  padding: 0;
  padding-top: 28px;
  padding-bottom: 28px;
  margin: 0;
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #E7E2DA;
  gap: 20px;
}

.List-module__column-1--FBq86 .List-module__ui-List-Item--xAUcA {
  gap: 20px;
}

.List-module__ui-List-Item-Leading--d35nF {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
}

.List-module__ui-List-Item-Content--GzJ14 {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  text-decoration: none;
  color: inherit;
}

.List-module__ui-List-Item-Leading--d35nF + .List-module__ui-List-Item-Content--GzJ14 {
  padding-left: 18px;
}

.List-module__ui-List-Item-Trailing--dUpun {
  display: flex;
  text-align: right;
  align-items: center;
  gap: 18px;
}

.List-module__ui-List-Item-Content--GzJ14 .List-module__title--WqJVB {
  font-size: 1.25rem; /* 20px */
  font-weight: 500;
}

.List-module__ui-List-Item-Content--GzJ14 .List-module__content--SnNnp {
  font-size: 0.875rem; /* 14px */
  color: #555555;
}

.List-module__ui-List-Item-Content--GzJ14 .List-module__description--WTZaH {
  font-size: 0.75rem; /* 12px */
  color: #888888;
}

.List-module__ui-List-Item-Content--GzJ14 .List-module__title--WqJVB + .List-module__content--SnNnp {
  padding-top: 7px;
}

.List-module__ui-List-Item-Content--GzJ14 .List-module__content--SnNnp + .List-module__description--WTZaH {
  padding-top: 5px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/List/List.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;;;;;;EAME,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,oBAAoB;EACpB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB,EAAE,SAAS;EAC7B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB,EAAE,SAAS;EAC9B,cAAc;AAChB;;AAEA;EACE,kBAAkB,EAAE,SAAS;EAC7B,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".root {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.column-1,\n.column-2,\n.column-3,\n.column-4,\n.column-5,\n.column-6 {\n  display: grid;\n  column-gap: 28px;\n}\n\n.column-1 {\n  grid-template-columns: repeat(1, minmax(0, 1fr));\n}\n\n.column-2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.column-3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.column-4 {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.column-5 {\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n}\n\n.column-6 {\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n}\n\n.ui-List-Item {\n  list-style: none;\n  padding: 0;\n  padding-top: 28px;\n  padding-bottom: 28px;\n  margin: 0;\n  display: flex;\n  flex-direction: row;\n  border-bottom: 1px solid #E7E2DA;\n  gap: 20px;\n}\n\n.column-1 .ui-List-Item {\n  gap: 20px;\n}\n\n.ui-List-Item-Leading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n}\n\n.ui-List-Item-Content {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: center;\n  text-decoration: none;\n  color: inherit;\n}\n\n.ui-List-Item-Leading + .ui-List-Item-Content {\n  padding-left: 18px;\n}\n\n.ui-List-Item-Trailing {\n  display: flex;\n  text-align: right;\n  align-items: center;\n  gap: 18px;\n}\n\n.ui-List-Item-Content .title {\n  font-size: 1.25rem; /* 20px */\n  font-weight: 500;\n}\n\n.ui-List-Item-Content .content {\n  font-size: 0.875rem; /* 14px */\n  color: #555555;\n}\n\n.ui-List-Item-Content .description {\n  font-size: 0.75rem; /* 12px */\n  color: #888888;\n}\n\n.ui-List-Item-Content .title + .content {\n  padding-top: 7px;\n}\n\n.ui-List-Item-Content .content + .description {\n  padding-top: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `List-module__root--EvFgj`,
	"column-1": `List-module__column-1--FBq86`,
	"column-2": `List-module__column-2--INPn_`,
	"column-3": `List-module__column-3--YBuOR`,
	"column-4": `List-module__column-4--VjOIR`,
	"column-5": `List-module__column-5--AyO38`,
	"column-6": `List-module__column-6--TzCND`,
	"ui-List-Item": `List-module__ui-List-Item--xAUcA`,
	"ui-List-Item-Leading": `List-module__ui-List-Item-Leading--d35nF`,
	"ui-List-Item-Content": `List-module__ui-List-Item-Content--GzJ14`,
	"ui-List-Item-Trailing": `List-module__ui-List-Item-Trailing--dUpun`,
	"title": `List-module__title--WqJVB`,
	"content": `List-module__content--SnNnp`,
	"description": `List-module__description--WTZaH`
};
export default ___CSS_LOADER_EXPORT___;
